import { render, staticRenderFns } from "./AreaInfo.vue?vue&type=template&id=81ebdbf4&scoped=true&"
import script from "./AreaInfo.vue?vue&type=script&lang=js&"
export * from "./AreaInfo.vue?vue&type=script&lang=js&"
import style0 from "./AreaInfo.vue?vue&type=style&index=0&id=81ebdbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ebdbf4",
  null
  
)

export default component.exports